module.exports = __webpack_public_path__ + "static/media/sabers.2020ac49.png";